import { Component, OnDestroy, OnInit } from '@angular/core';
import {style, animate, transition, trigger, group} from '@angular/animations';
import { SharedscrollstatusService } from '../../services/index';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service'
import { User } from '../../models/index'
import { Error } from '../../models/index'
import { ConfirmedValidator } from '../headerhome/confirm-validator';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'app-headermain',
    templateUrl: './headermain.component.html',
    styleUrls: ['./headermain.component.css'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({
                    opacity: 0,
                    transform: 'translateX(-100%)'
                }),
                group([
                    animate(500, style({ opacity: 1 })),
                    animate('500ms ease-in', style({ transform: 'translateX(0%)' }))
                ])
            ]),
            transition(':leave', [
                group([
                    animate(500, style({ opacity: 0 })),
                    animate('500ms ease-in', style({ transform: 'translateX(-100%)' }))
                ])
            ])
        ])
    ],
    standalone: false
})
export class HeadermainComponent implements OnInit, OnDestroy {
  readonly navLinks = environment.navLinks;
  readonly accountUrl = environment.navLinks.account || `${environment.navLinks.buses}account`;
  public toggle:boolean;
    signupForm: UntypedFormGroup;
    startForm: UntypedFormGroup;
    loginForm: UntypedFormGroup;
    resetForm: UntypedFormGroup;
    codeForm: UntypedFormGroup;
    passwordUpdateForm: UntypedFormGroup;
    submitted=false;
    loginsubmitted=false;
    accepted_terms=false;
    numberSubmitted=false;
    is_loggedin=false;
    success:boolean=false;
    successLogin:boolean=false;
    loadingStart:boolean = false;
    loadingSignup:boolean = false;
    loadingLogin:boolean = false;
    resetsubmitted:boolean = false;
    loadingReset:boolean = false;
    successReset:boolean = false;
    codeubmitted:boolean=false;
    loadingCode:boolean=false;
    updateSubmitted:boolean = false;
    loadingPasswordUpdate:boolean = false;
    loadingUpdatePassword:boolean = false;
    successPasswordUpdate:boolean = false;
    updatePassSuccessMsg: string;
    isHidden:boolean = true;
    successode:boolean = true;
    startEmail:any;
    resetErrMsg:any;
    resetSuccessMsg:any;
    codeSuccessMsg:string;
    passToken:string;
    resMsg:any;
    res:any;
    resLogin:any;
    isLoggedIn:any;
    resendingOtp: boolean = false;
    is_email_otp:boolean = false;
    opt_phone_email:string;
    user:User;
    api_error:Error;
    fieldTextType: boolean;
    api_error_login:any;
    user_email_reset:string;
    timer: number = 120; // countdown duration in seconds
    interval: any;
    canResend: boolean = false;
    private destroy$ = new Subject<void>();
    constructor(
      private service:SharedscrollstatusService,
      private _fb: UntypedFormBuilder,
      private users:UserService,
      private router: Router) {
    this.service.currentValue.subscribe(message => this.toggle = message);//subscribe to the currentValue observable.
    this.signupForm = _fb.group({
      first_name:['', Validators.required],
      last_name:['', Validators.required],
      phone_number:['', [Validators.required,Validators.pattern('^(?:254|\\+254|0)(7|1)[0-9]{8}$')]],
      id_number:['',[ Validators.required,Validators.pattern('^[a-zA-Z0-9]*$'),Validators.minLength(7),Validators.maxLength(14)]],
      email:['', [Validators.required,Validators.email]],
      password:['', [Validators.required,Validators.minLength(6)]],
    });

    this.codeForm = _fb.group({
      otp_code:['', Validators.required],
    });
    this.passwordUpdateForm = _fb.group({
      password:['', [Validators.required,Validators.minLength(8)]],
      confirmpassword:['', [Validators.required,Validators.minLength(8)]],
    },{ 
      validator: ConfirmedValidator('password', 'confirmpassword')
    });

    this.startForm = _fb.group({
      phone_or_email: ['', [Validators.required, this.emailOrPhoneValidator]]
    });
    this.resetForm = _fb.group({
      email:['', [Validators.required,Validators.email]],
    });
    this.loginForm = _fb.group({
      password:['', Validators.required],
    });
  }

  ngOnInit() {
    this.users.refreshAuthState();
    this.users.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe((userData) => {
        this.isLoggedIn = this.users.isAuthenticated();
        this.user = userData ? new User().deserialize(userData) : new User();
      });
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    this.destroy$.next();
    this.destroy$.complete();
  }

   emailOrPhoneValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^(?:254|\+254|0)(7|1)[0-9]{8}$/;
  
    if (emailRegex.test(value) || phoneRegex.test(value)) {
      return null; // valid
    }
  
    return { invalidContact: true };
  }

  logoutUser(){
    this.users.logout();
    this.isLoggedIn=false;
    this.router.navigate(['/']);
  }

  get accountInitials(): string {
    const fullName = this.user?.fullName?.trim();
    if (fullName) {
      const initials = fullName
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
      if (initials) {
        return initials;
      }
    }

    const email = this.user?.email?.trim();
    if (email) {
      return email.charAt(0).toUpperCase();
    }

    return 'A';
  }

  get accountDisplayName(): string {
    return this.user?.first_name || this.user?.fullName || this.user?.email || 'Account';
  }

  redirectToExternalAccount(): void {
    if (typeof window !== 'undefined') {
      window.location.href = this.accountUrl;
    }
  }

  getUserProfile(user:any){
    this.users.getProfile(user).subscribe(
      response => {
          this.loadingStart=false;
          this.resMsg=response;
          this.users.setAuthenticatedUser(this.resMsg.data);
          this.user=new User().deserialize(this.resMsg.data)
          this.isLoggedIn=true;
      },
      error => {
       this.user = new User();
       this.users.refreshAuthState();
       this.isLoggedIn = this.users.isAuthenticated();
      }
    );
  }


submitStart = () => {
  this.loadingStart=true;
  this.loginsubmitted=true;
  if (this.startForm.invalid ) {
      this.loadingStart=false;
      return;
  }
  let user_email=this.startEmail= this.startForm.value.email;
  this.users.checkEmail(user_email).subscribe(
    response => {
        this.loadingStart=false;
        document.getElementById("closeStart")?.click();
        document.getElementById("openModalButton")?.click();

    },
    error => {
      this.loadingStart=false;
      this.api_error=new Error().deserialize(error.error.errors)
      if(!error.error.status){
        this.signupForm.patchValue({email:user_email });
        document.getElementById("closeStart")?.click();
        document.getElementById("openSignupButton")?.click();
      }
    }
  );
}
backToEmail= () => {
      this.loginsubmitted=false
      document.getElementById("openModalStart")?.click();
      document.getElementById("closePassword")?.click();
}
initiateResetPassword= () => {
      document.getElementById("closePassword")?.click();
      document.getElementById("openModalReset")?.click();
}

eventClick = (event: string) => {
  return event;
}

toggleFieldTextType= () => {
  this.fieldTextType = !this.fieldTextType;
}
 get f() { return this.signupForm.controls; }

submitSignUp = () => {
    this.submitted = true;
    this.loadingSignup=true;
    // stop here if form is invalid
    if (this.signupForm.invalid ) {
      this.submitted = false;
      this.loadingSignup=false;
        return;
    }
    let value = this.signupForm.value;
    let webformdata={
      "first_name": value.first_name,
      "last_name": value.last_name,
      "email": value.email,
      "password": value.password,
      "id_number": value.id_number,
      "phone_number": '+254'+ value.phone_number.substring(1)
    }

    this.users.signUp(webformdata).subscribe(
      response => {
        this.loadingSignup=false;
          this.success = true;
          this.resMsg=response;
          this.res= this.resMsg.data.message;
          document.getElementById("closeSignup")?.click();
          document.getElementById("openSuccessButton")?.click();
      },
      error => {
          this.success = false;
          this.loadingSignup=false;
          this.user=new User().deserialize(error.error.errors[0])
      }
    );
}


otpSignUp = () => {
  this.loadingStart=true;

  if (!this.accepted_terms) {
    this.loadingStart = false;
    return;
  }

  this.numberSubmitted = true;
  // stop here if form is invalid
  if (this.startForm.invalid ) {
    this.numberSubmitted = false;
    this.loadingStart=false;
      return;
  }

  const value = this.startForm.get('phone_or_email')?.value;

  var webformdata:any={
  };



  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    // It's an email
    this.is_email_otp =true
    webformdata.email = value;
  } else {
    // It's a phone
    this.is_email_otp =false
    webformdata.phone_number = value;
    webformdata.phone_number = '+254' + value.slice(-9);
  }
  // webformdata.otp_request = true;
  // webformdata.password = value;
  
  this.opt_phone_email = this.is_email_otp ? value : webformdata.phone_number;
  this.startOTPTimer();

  this.users.signUp(webformdata).subscribe(
    response => { 
      this.loadingStart=false;
        this.success = true;
        this.resMsg=response;
        this.res= this.resMsg.data.message;
        document.getElementById("closeStart")?.click();
        document.getElementById("openOtpCodeButton")?.click();
    },
    error => {
        this.success = false;
        this.loadingStart=false;
        this.user=new User().deserialize(error.error.errors[0])
    }
  );
}
resendOtpCode = () => {
  this.canResend = false;
  this.startOTPTimer();
  const value = this.startForm.get('phone_or_email')?.value;
  const webformdata: any = {}; 
  if (this.is_email_otp) {
    webformdata.email = value;
  } else {
    webformdata.phone_number = '+254' + value.slice(-9);
  }

  this.users.signUp(webformdata).subscribe(
    response => {
      this.success = true;
      this.resMsg = response;
      this.res = this.resMsg.data.message;
    },
    error => {
      this.success = false;
      this.user = new User().deserialize(error.error.errors[0]);
    }
  );
};

  // send reset code to verify
  otpSubmitCode = () =>{
    this.codeubmitted=true;
    this.loadingCode=true;
   if (this.codeForm.invalid ) {
    this.codeubmitted=false;
    this.loadingCode=false;
      return;
   }
  let value = this.codeForm.value;
  
  let webformCode={
    [this.is_email_otp ? 'email' : 'phone_number']: this.opt_phone_email,
    "otp_code": value.otp_code
  }
  
  this.users.login(webformCode).subscribe(
    response => {
        this.loadingCode=false;
        this.codeubmitted=false;
        this.successode = true;
        this.resMsg=response;
        this.codeSuccessMsg=this.resMsg.data.message;
        this.passToken=this.resMsg.data.token;
        document.getElementById("closeCode")?.click();
        if(this.resMsg.data){
          this.users.setAuthenticatedUser(this.resMsg.data);
          this.user=new User().deserialize(this.resMsg.data)
          this.isLoggedIn=true;
          document.getElementById("closePassword")?.click();
          this.redirectToExternalAccount();
          
        }
    },
    error => {
        this.successode = false;
        this.codeubmitted=false;
        this.loadingCode=false;
        this.api_error= new Error().deserialize(error.error.errors);
        this.codeSuccessMsg=this.api_error['0'].error;

    }
  );
  }

acceptedTerms(){
  this.accepted_terms=!this.accepted_terms;
}

startOTPTimer() {
  this.timer = 120;
  this.canResend = false;

  this.interval = setInterval(() => {
    this.timer--;
    if (this.timer === 0) {
      clearInterval(this.interval);
      this.canResend = true;
    }
  }, 1000);
}


submitLogin = () => {
      this.loginsubmitted=true;
      this.loadingLogin=true;
     if (this.loginForm.invalid ) {
      this.loginsubmitted=false;
      this.loadingLogin=false;
        return;
     }
    let value = this.loginForm.value;
    let webformlogin={
      "password": value.password,
      'email':this.startEmail,
    }

    this.users.login(webformlogin).subscribe(
      response => {
          this.loadingLogin=false;
          this.loginsubmitted=false;
          this.successLogin = true;
          this.resMsg=response;
          if(this.resMsg.data){
            this.users.setAuthenticatedUser(this.resMsg.data);
            this.user=new User().deserialize(this.resMsg.data)
            this.isLoggedIn=true;
            document.getElementById("closePassword")?.click();
            this.redirectToExternalAccount();
            
          }
      },
      error => {
          this.successLogin = false;
          this.loginsubmitted=false;
          this.loadingLogin=false;
          
          this.api_error=new Error().deserialize(error.error.errors[0])
          this.api_error_login=this.api_error[0];
      }
    );
}

submitResetPassword = () =>{
  this.resetsubmitted=true;
  this.loadingReset=true;
 if (this.resetForm.invalid ) {
  this.resetsubmitted=false;
  this.loadingReset=false;
    return;
 }
let value = this.resetForm.value;
let webformReset={
  "email": value.email
}
this.users.passwordReset(webformReset).subscribe(
  response => {
      this.loadingReset=false;
      this.resetsubmitted=false;
      this.successReset = true;
      this.resMsg=response;
      this.resetSuccessMsg=this.resMsg.data.message;
      this.user_email_reset=value.email;
      document.getElementById("openCodeButton")?.click();
      document.getElementById("closeReset")?.click();
  },
  error => {
      this.successReset = false;
      this.resetsubmitted=false;
      this.loadingReset=false;
      this.api_error= new Error().deserialize(error.error.errors);
      this.resetErrMsg=this.api_error['0'];
  }
);
}

// send reset code to verify
updatePassword= () =>{
  this.updateSubmitted=true;
  this.loadingPasswordUpdate=true;
 if (this.passwordUpdateForm.invalid ) {
    this.updateSubmitted=false;
    this.loadingPasswordUpdate=false;
    return;
 }
let value = this.passwordUpdateForm.value;

let webformCode={
  "email": this.user_email_reset,
  "new_password": value.password,
  "token": this.passToken
}
this.users.sendUpdatePassword(webformCode).subscribe(
  response => {
      this.loadingUpdatePassword=false;
      this.updateSubmitted=false;
      this.successPasswordUpdate = true;
      this.resMsg=response;
      this.updatePassSuccessMsg=this.resMsg.data.message;
      document.getElementById("closePasswordUpdate")?.click();
      document.getElementById("openResetSuccessButton")?.click();
  },
  error => {
      this.successPasswordUpdate = false;
      this.updateSubmitted=false;
      this.loadingPasswordUpdate=false;
      this.api_error= new Error().deserialize(error.error.errors);
      this.updatePassSuccessMsg=this.api_error['0'];
  }
);
}



}
